// extracted by mini-css-extract-plugin
export var CompanyBlock = "footer-module--CompanyBlock--9c5c1";
export var CompanyLogo = "footer-module--CompanyLogo--ad53e";
export var FooterContent = "footer-module--FooterContent--4d940";
export var FooterWrapper = "footer-module--FooterWrapper--c2056";
export var LeftBlock = "footer-module--LeftBlock--ce4c3";
export var OutsideLink = "footer-module--OutsideLink--3736f";
export var OutsideLinks = "footer-module--OutsideLinks--2026d";
export var RightBlock = "footer-module--RightBlock--966f6";
export var Rights = "footer-module--Rights--c70d8";